// ** Icons Import
import {
  Copy,
  Circle,
  Box,
  Package,
  RotateCw,
  AlertTriangle
} from 'react-feather'

export default [
  {
    header: 'Forms & Tables'
  },
  {
    id: 'formElements',
    title: 'Form Elements',
    icon: <Copy size={20} />,
    children: [
      {
        action: 'concession-level-1',
        resource: 'TollSystem',
        id: 'input',
        title: 'Input',
        icon: <Circle size={12} />,
        navLink: '/forms/elements/input'
      },
      {
        action: 'concession-level-1',
        resource: 'TollSystem',
        id: 'inputGroup',
        title: 'Input Groups',
        icon: <Circle size={12} />,
        navLink: '/forms/elements/input-group'
      },
      {
        action: 'concession-level-1',
        resource: 'TollSystem',
        id: 'inputMask',
        title: 'Input Mask',
        icon: <Circle size={12} />,
        navLink: '/forms/elements/input-mask'
      },
      {
        action: 'concession-level-1',
        resource: 'TollSystem',
        id: 'textarea',
        title: 'Textarea',
        icon: <Circle size={12} />,
        navLink: '/forms/elements/textarea'
      },
      {
        action: 'concession-level-1',
        resource: 'TollSystem',
        id: 'checkbox',
        title: 'Checkbox',
        icon: <Circle size={12} />,
        navLink: '/forms/elements/checkbox'
      },
      {
        action: 'concession-level-1',
        resource: 'TollSystem',
        id: 'radio',
        title: 'Radio',
        icon: <Circle size={12} />,
        navLink: '/forms/elements/radio'
      },
      {
        action: 'concession-level-1',
        resource: 'TollSystem',
        id: 'switch',
        title: 'Switch',
        icon: <Circle size={12} />,
        navLink: '/forms/elements/switch'
      },
      {
        action: 'concession-level-1',
        resource: 'TollSystem',
        id: 'select',
        title: 'Select',
        icon: <Circle size={12} />,
        navLink: '/forms/elements/select'
      },
      {
        action: 'concession-level-1',
        resource: 'TollSystem',
        id: 'numberInput',
        title: 'Number Input',
        icon: <Circle size={12} />,
        navLink: '/forms/elements/number-input'
      },
      {
        action: 'concession-level-1',
        resource: 'TollSystem',
        id: 'fileUploader',
        title: 'File Uploader',
        icon: <Circle size={12} />,
        navLink: '/forms/elements/file-uploader'
      },
      {
        action: 'concession-level-1',
        resource: 'TollSystem',
        id: 'quillEditor',
        title: 'Editor',
        icon: <Circle size={12} />,
        navLink: '/forms/elements/editor'
      },
      {
        action: 'concession-level-1',
        resource: 'TollSystem',
        id: 'date_&_timePicker',
        title: 'Date & Time Picker',
        icon: <Circle size={12} />,
        navLink: '/forms/elements/pickers'
      }
    ]
  },
  {
    action: 'concession-level-1',
    resource: 'TollSystem',
    id: 'formLayouts',
    title: 'Form Layout',
    icon: <Box size={20} />,

    navLink: '/forms/layout/form-layout'
  },
  {
    action: 'concession-level-1',
    resource: 'TollSystem',
    id: 'wizard',
    title: 'Form Wizard',
    icon: <Package size={20} />,

    navLink: '/forms/wizard'
  },
  {
    action: 'concession-level-1',
    resource: 'TollSystem',
    id: 'formValidation',
    title: 'Form Validation',
    icon: <AlertTriangle size={12} />,
    navLink: '/forms/form-validation'
  },
  {
    action: 'concession-level-1',
    resource: 'TollSystem',
    id: 'formRepeater',
    title: 'Form Repeater',
    icon: <RotateCw size={20} />,
    navLink: '/forms/form-repeater'
  }
]
